<script setup lang="ts">
import { type IconType } from '@/types/components/IconType'
import { EColors } from '@/types/constants/ColorValues'
import BaseButton from './BaseButton.vue'

interface ButtonProps {
    label?: string
    icon?: IconType
}

defineProps<ButtonProps>()
defineEmits<{
    (e: 'click', event: MouseEvent): void
}>()
</script>

<template>
    <BaseButton
        :icon="icon"
        :label="label"
        :type="EColors.PRIMARY"
        @click="$event => $emit('click', $event)"
        v-bind="$attrs">
        <slot />
    </BaseButton>
</template>
